<template>
  <div class="head-container">
    <div v-if="$slots.actions" class="crud-opts">
      <span class="crud-opts-left">
        <slot name="actions" />
      </span>
    </div>
    <div class="filter-container">
      <slot name="filters" />
      <el-button
        class="filter-item"
        size="mini"
        type="primary"
        icon="el-icon-search"
        @click="$emit('search')"
      >
        查询
      </el-button>
      <el-button
        class="filter-item"
        size="mini"
        icon="el-icon-refresh-left"
        @click="$emit('reset')"
      >
        重置
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolListToolbar'
}
</script>
